"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorCodeMapperInternal = exports.ErrorCodeMapper = void 0;
var _defaultTranslations = require("../constants/defaultTranslations");
var _TranslationKey = require("./TranslationKey");
const errorCodesMap = new Map([['105', {
  id: _TranslationKey.TranslationKey.validationRequired,
  defaultMessage: _defaultTranslations.defaultTranslations.validationRequired
}], ['119', {
  id: _TranslationKey.TranslationKey.validationLength,
  defaultMessage: _defaultTranslations.defaultTranslations.validationLength
}], ['106', {
  id: _TranslationKey.TranslationKey.validationRegex,
  defaultMessage: _defaultTranslations.defaultTranslations.validationRegex
}], ['108', {
  id: _TranslationKey.TranslationKey.validationUniqueEmail,
  defaultMessage: _defaultTranslations.defaultTranslations.validationUniqueEmail
}], ['121', {
  id: _TranslationKey.TranslationKey.validationEmailTerminatedCustomer,
  defaultMessage: _defaultTranslations.defaultTranslations.validationEmailTerminatedCustomer
}]]);
class ErrorCodeMapperInternal {
  getLocalizationKey(errorCode) {
    let localization;
    if (errorCode) {
      localization = errorCodesMap.get(errorCode);
    }
    return localization ?? {
      id: _TranslationKey.TranslationKey.errorOccured,
      defaultMessage: _defaultTranslations.defaultTranslations.errorOccured
    };
  }
}
exports.ErrorCodeMapperInternal = ErrorCodeMapperInternal;
const ErrorCodeMapper = exports.ErrorCodeMapper = new ErrorCodeMapperInternal();
//# sourceMappingURL=ErrorCodeMapper.js.map